<app-breadcrumbs></app-breadcrumbs>
<div class="store-number-toolbar">
  <div [cfaLoading]="isLoading">
    <button mat-raised-button (click)="getLanHealth()" color="primary" id="store-number-search-button">
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput maxlength="5" minlength="5" (keydown.enter)="getLanHealth()" [(ngModel)]="storeNumber" autofocus/>
    </mat-form-field>
  </div>
  <app-health-nav [storeNumber]="storeNumber"></app-health-nav>
</div>

<div class="main-card-wrapper">
  <div class="slo-evaluation-wrapper">
    <div class="row">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Service Level Objective Evalutation</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-divider></mat-divider>
          <table class="table" id="slo-evaluation-table">
            <thead>
              <tr>
                @if (fortigateGlobalStatistics != null) {
                  <th scope="col">FortiGate CPU Util.</th>
                }
                @if (fortigateGlobalStatistics != null) {
                  <th scope="col">FortiGate Mem. Util.</th>
                }
                @if (fortigateGlobalStatistics != null) {
                  <th scope="col">FortiGate Sessions</th>
                }
                @if (networkState && networkState !== NETWORK_STATE.ON_WAN1) {
                  <th scope="col">Network State</th>
                }
                @for (interface of interfaceThroughput | keyvalue; track interface) {
                  <th scope="col">
                    {{interface.key}}
                  </th>
                }
                @if (posServices.length > 0) {
                  <th scope="col">
                    <span>Pos Services</span>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr>
                @if (fortigateGlobalStatistics != null) {
                  <td>
                    @if (fortigateGlobalStatistics.CPUUsage <= 50) {
                      <span class="online-badge">
                        <mat-icon matTooltip="Less than or equal to 50%" matTooltipPosition="right">
                          check_circle_outline
                        </mat-icon>
                      </span>
                    }
                    @if (fortigateGlobalStatistics.CPUUsage > 50) {
                      <span class="offline-badge">
                        <mat-icon matTooltip="Greater than 50%" matTooltipPosition="right">
                          highlight_off
                        </mat-icon>
                      </span>
                    }
                  </td>
                }
                @if (fortigateGlobalStatistics != null) {
                  <td>
                    @if (fortigateGlobalStatistics.MemUsage <= 75) {
                      <span class="online-badge">
                        <mat-icon matTooltip="Less than or equal to 75%" matTooltipPosition="right">
                          check_circle_outline
                        </mat-icon>
                      </span>
                    }
                    @if (fortigateGlobalStatistics.MemUsage > 75) {
                      <span class="offline-badge">
                        <mat-icon matTooltip="Greater than 75%" matTooltipPosition="right">
                          highlight_off
                        </mat-icon>
                      </span>
                    }
                  </td>
                }
                @if (fortigateGlobalStatistics != null) {
                  <td>
                    @if (fortigateGlobalStatistics.NumSessions <= 3000) {
                      <span class="online-badge">
                        <mat-icon matTooltip="Less than or equal to 3000" matTooltipPosition="right">
                          check_circle_outline
                        </mat-icon>
                      </span>
                    }
                    @if (fortigateGlobalStatistics.NumSessions > 3000) {
                      <span class="offline-badge">
                        <mat-icon matTooltip="Greater than 3000" matTooltipPosition="right">
                          highlight_off
                        </mat-icon>
                      </span>
                    }
                  </td>
                }
                @if (networkState && networkState !== NETWORK_STATE.ON_WAN1) {
                  <td>
                    @if (networkState === NETWORK_STATE.ON_WAN2) {
                      <span class="offline-badge">
                        <mat-icon [matTooltip]="networkStateEvaluation?.tooltip" [matTooltipClass]="'my-tooltip'"
                          matTooltipPosition="right">
                          signal_cellular_alt
                        </mat-icon>
                      </span>
                    }
                    @if (networkState === NETWORK_STATE.EM_FAILOVER) {
                      <span class="offline-badge">
                        <mat-icon [matTooltip]="networkStateEvaluation?.tooltip" [matTooltipClass]="'my-tooltip'"
                          matTooltipPosition="right">
                          priority_high
                        </mat-icon>
                      </span>
                    }
                    @if (networkState === NETWORK_STATE.OFFLINE) {
                      <span class="offline-badge">
                        <mat-icon [matTooltip]="networkStateEvaluation?.tooltip" [matTooltipClass]="'my-tooltip'"
                          matTooltipPosition="right">
                          block
                        </mat-icon>
                      </span>
                    }
                    @if (networkState === NETWORK_STATE.UNKNOWN) {
                      <span class="offline-badge">
                        <mat-icon [matTooltip]="networkStateEvaluation?.tooltip" [matTooltipClass]="'my-tooltip'"
                          matTooltipPosition="right">
                          help_outline
                        </mat-icon>
                      </span>
                    }
                  </td>
                }
                @for (interface of interfaceThroughput | keyvalue; track interface) {
                  <td>
                    @if (interface.value.in <= 15 && interface.value.out <= 15) {
                      <span class="online-badge">
                        <mat-icon matTooltip="Greater than or equal to 15 Mbps" matTooltipPosition="right">
                          check_circle_outline
                        </mat-icon>
                      </span>
                    }
                    @if (interface.value.in > 15 || interface.value.out > 15) {
                      <span class="offline-badge">
                        <mat-icon matTooltip="Less than 15 Mbps" matTooltipPosition="right">
                          highlight_off
                        </mat-icon>
                      </span>
                    }
                  </td>
                }
                @if (posServices.length > 0) {
                  <td>
                    @if (isPosServiceOnline) {
                      <span class="online-badge">
                        <mat-icon matTooltip="All checked Pos services online" matTooltipPosition="right">
                          check_circle_outline
                        </mat-icon>
                      </span>
                    }
                    @if (!isPosServiceOnline) {
                      <span class="offline-badge">
                        <mat-icon matTooltip="Some Pos services are offline" matTooltipPosition="right">
                          highlight_off
                        </mat-icon>
                      </span>
                    }
                  </td>
                }
              </tr>
            </tbody>
          </table>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="zone router-zone">
    <div class="zone-header">
      <span class="status-dot status-{{getRouterSeverity()}}"></span>
      <h3 class="zone-title">Routers &amp; Services</h3>
    </div>
    <div class="router-card-wrapper">
    @if (interfaceThroughput != null) {
      <div class="interface-throughput-wrapper">
        <mat-card>
          <mat-card-header>
            <mat-card-title>Interface Throughput</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-divider></mat-divider>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Interface</th>
                  <th scope="col">Mbps In</th>
                  <th scope="col">Mbps Out</th>
                </tr>
              </thead>
              <tbody>
                @for (interface of interfaceThroughput | keyvalue; track interface) {
                  <tr>
                    <td>{{interface.key}}</td>
                    <td>{{interface.value.in}}</td>
                    <td>{{interface.value.out}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </mat-card-content>
        </mat-card>
      </div>
    }
    <div class="fortigate-card-wrapper">
      @if (fortigate != null && fortigateGlobalStatistics != null && primaryVpnStatus != null) {
        <div class="fortigate-card-wrapper device-card-wrap"
          [class.is-online]="fortigate.conn_status === 1"
          [class.is-warn]="fortigate.conn_status === 0"
          [class.is-offline]="fortigate.conn_status === 2">
          <mat-card>
            <mat-card-header>
              <mat-card-title>{{fortigate.hostname}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-divider></mat-divider>
              @if (fortigate.conn_status == 0) {
                <span id="network-health-badge-yellow">
                  <mat-icon matTooltip="Health: Unknown" matTooltipPosition="right">network_check</mat-icon>
                </span>
              }
              @if (fortigate.conn_status == 1) {
                <span id="network-health-badge-green">
                  <mat-icon matTooltip="Health: good" matTooltipPosition="right">network_check</mat-icon>
                </span>
              }
              @if (fortigate.conn_status == 2) {
                <span id="network-health-badge-red">
                  <mat-icon matTooltip="Health: bad" matTooltipPosition="right">network_check</mat-icon>
                </span>
              }
              @if (fortigate.conn_status == 0) {
                <p><b>Status:</b> Unknown</p>
              }
              @if (fortigate.conn_status == 1) {
                <p><b>Status:</b> Online</p>
              }
              @if (fortigate.conn_status == 2) {
                <p><b>Status:</b> Offline</p>
              }
              @if (fortigate.conn_status == 0) {
                <p><b>VPN Status:</b> Offline</p>
              }
              @if (fortigate.conn_status == 1) {
                <p><b>VPN Status:</b> Online</p>
              }
              <p><b>IP:</b> {{fortigate.ip}}</p>
              <p><b>Serial:</b> {{fortigate.sn}}</p>
              <p><b>CPU:</b> {{fortigateGlobalStatistics.CPUUsage}}%</p>
              <p><b>Memory:</b> {{fortigateGlobalStatistics.MemUsage}}%</p>
              <p><b>Sessions:</b> {{fortigateGlobalStatistics.NumSessions}}</p>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
    @if (cradlepoints.length > 0 && cradlepointLanAvailability != null) {
      <div class="cradlepoint-card-wrapper">
        @for (cradlepoint of cradlepoints; track cradlepoint) {
          <div class="cradlepoint-card-wrapper device-card-wrap"
            [class.is-online]="cradlepoint.state === 'online'"
            [class.is-offline]="cradlepoint.state !== 'online'">
            <mat-card>
              <mat-card-header>
                <mat-card-title>{{cradlepoint.name}}</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <mat-divider></mat-divider>
                @if (cradlepoint.state == 'online') {
                  <span id="network-health-badge-green">
                    <mat-icon matTooltip="Health: good" matTooltipPosition="right">network_check</mat-icon>
                  </span>
                }
                @if (cradlepoint.state == 'offline') {
                  <span id="network-health-badge-red">
                    <mat-icon matTooltip="Health: bad" matTooltipPosition="right">network_check</mat-icon>
                  </span>
                }
                @if (cradlepoint.state == 'online') {
                  <p><b>Status:</b> Online</p>
                }
                @if (cradlepoint.state == 'offline') {
                  <p><b>Status:</b> Offline</p>
                }
                @if (networkState === NETWORK_STATE.ON_WAN1) {
                  <p><b>Network State:</b> On WAN1</p>
                }
                @if (networkState === NETWORK_STATE.ON_WAN2) {
                  <p><b>Network State:</b> On WAN2</p>
                }
                @if (networkState === NETWORK_STATE.EM_FAILOVER) {
                  <p><b>Network State:</b> EM Failover</p>
                }
                @if (networkState === NETWORK_STATE.OFFLINE) {
                  <p><b>Network State:</b> Offline</p>
                }
                @if (cradlepoint.state == 'offline') {
                  <p><b>Status:</b> Offline</p>
                }
                <p><b>Mac:</b> {{cradlepoint.mac}}</p>
                <p><b>IPv4 Address:</b> {{cradlepoint.ipv4_address}}</p>
                <p><b>Serial:</b> {{cradlepoint.serial_number}}</p>
                <p><b>Ping Loss:</b> {{cradlepointLanAvailability.PingLossPercent}}%</p>
                <p><b>Avg. RTT:</b> {{cradlepointLanAvailability.avgrtt}} ms</p>
              </mat-card-content>
            </mat-card>
          </div>
        }
      </div>
    }
    @if (posServices.length > 0) {
      <div class="pos-services-card-wrapper">
        <div class="device-card-wrap" [class.is-online]="isPosServiceOnline" [class.is-offline]="!isPosServiceOnline">
          <app-pos-services-card class="pos-card" [pos_services]="posServices"></app-pos-services-card>
        </div>
      </div>
    }
    </div>
  </div>
  @if (portStatuses != null) {
    <div class="zone meraki-zone">
      <div class="zone-header">
        <span class="status-dot status-{{getMerakiSeverity()}}"></span>
        <h3 class="zone-title">Switches</h3>
        <span class="device-count">{{merakiSwitchStatuses.length}}</span>
      </div>
      <div class="meraki-card-wrapper">
      @for (portStatus of portStatuses | keyvalue; track portStatus; let i = $index) {
        <div>
          <div class="device-card-wrap" [class.is-online]="merakiSwitchStatuses[i]?.status === 'online'"
            [class.is-offline]="merakiSwitchStatuses[i]?.status !== 'online'">
            <app-meraki-card [meraki_switch_status]="merakiSwitchStatuses[i]"></app-meraki-card>
          </div>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>Port Information</mat-panel-title>
            </mat-expansion-panel-header>
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Status</th>
                  <th>Speed</th>
                  <th>Duplex</th>
                  <th>Clients</th>
                  <th>Traffic</th>
                  <th>Errors</th>
                </tr>
              </thead>
              <tbody>
                @for (port of portStatus.value; track port) {
                  <tr>
                    <td>{{port.portId}}</td>
                    <td>
                      @if (port.status == 'Connected') {
                        <span class="online-badge">
                          <mat-icon matTooltip="Connected" matTooltipPosition="right">
                            check_circle_outline
                          </mat-icon>
                        </span>
                      }
                      @if (port.status == 'Disconnected') {
                        <span class="offline-badge">
                          <mat-icon matTooltip="Disconnected" matTooltipPosition="right">
                            highlight_off
                          </mat-icon>
                        </span>
                      }
                    </td>
                    <td>{{port.speed}}</td>
                    <td>{{port.duplex}}</td>
                    <td>{{port.clientCount}}</td>
                    <td>{{port.trafficInKbps.total}}</td>
                    <td>
                      @if (port.errors.length > 0) {
                        <span>
                          @for (error of port.errors; track error) {
                            <span class="offline-badge">
                              <mat-icon matTooltip={{error}} matTooltipPosition="right">
                                highlight_off
                              </mat-icon>
                            </span>
                          }
                        </span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </mat-expansion-panel>
        </div>
      }
      </div>
    </div>
  }
</div>